import { useMemo } from 'react';
import { BannerWrapper } from './banner.styles';
import { BANNER_CONFIG } from './constants/banner.config';
import { isMobile } from 'react-device-detect';
import { BANNER_DESKTOP_CONFIG } from './constants/banner.desktop.config';

const Banner = ({ type, promo, lang }) => {
	const pickedImage = useMemo(() => {
		if (!type) {
			return null;
		}

		const validatedFormat = type?.toLowerCase();

		const config = isMobile ? BANNER_CONFIG : BANNER_DESKTOP_CONFIG;

		return promo
			? config[lang][validatedFormat]?.promo
			: config[lang][validatedFormat]?.normal;
	}, [type, promo]);

	return (
		<BannerWrapper>
			<img src={pickedImage} />
		</BannerWrapper>
	);
};

export default Banner;
